import Button from '@liquidweb-dev/undercurrent/Button';
import Stack from '@liquidweb-dev/undercurrent/Stack';

import LWForm, { type FormSubmitHandler } from 'components/LWForm';
import HookedCreditCardFields from 'components/standard/Form/HookedCreditCardFields';
import HookedSubmit from 'components/standard/Form/HookedSubmit';
import {
	creditCardValidators,
	useAcceptJs,
	useLoadAcceptJs,
} from 'modules/creditCard';
import { useDialogMakePaymentContext } from '../dialogMakePaymentContext';

const NewCard = () => {
	const {
		formErrors,
		formValues,
		clearSensitiveFormValues,
		setFormErrors,
		setFormValues,
		setOpaqueData,
		setStep,
	} = useDialogMakePaymentContext();

	const hasLoadedAcceptJsScript = useLoadAcceptJs(true);
	const { isSubmittingAcceptJs, submitAcceptJs, readyToSubmitAcceptJs } =
		useAcceptJs();

	const handleSubmit: FormSubmitHandler<typeof formValues> = async (values) => {
		const { errors: acceptJsErrors, opaqueData } = await submitAcceptJs({
			cardNumber: values.cardNumber,
			expirationDate: values.expirationDate,
			cardCode: values.cardCode,
		});

		if (acceptJsErrors) {
			setFormErrors((prev) => ({ ...prev, ...acceptJsErrors }));
			return;
		}

		setOpaqueData(opaqueData);
		setStep('confirmOneTimePayment');
	};

	const handleGoBack = () => {
		clearSensitiveFormValues();
		setStep('choosePaymentMethod');
	};

	return (
		<LWForm
			values={formValues}
			errors={formErrors}
			onValuesChange={setFormValues}
			onErrorsChange={setFormErrors}
			onSubmit={handleSubmit}
			validators={creditCardValidators}
		>
			<HookedCreditCardFields />

			<Stack sx={{ flexDirection: 'row', gap: 100, marginTop: 200 }}>
				<Button
					onClick={handleGoBack}
					size="large"
					variant="secondary"
					sx={{ flex: 1 }}
				>
					Go back
				</Button>
				<HookedSubmit
					disabled={!hasLoadedAcceptJsScript || !readyToSubmitAcceptJs}
					loading={isSubmittingAcceptJs}
					size="large"
					variant="primary"
					sx={{ flex: 1 }}
				>
					Continue
				</HookedSubmit>
			</Stack>
		</LWForm>
	);
};

export default NewCard;
